import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { useIntl } from 'react-intl';
import { messages } from './messages';

/** Used inside clickable rows: React bubbles events from the confirm popup's portal up to the row. */
export function DeleteLocalDraftButton({
  isDeleting,
  isSubmitted = false,
  onDelete,
}: {
  isDeleting: boolean;
  isSubmitted?: boolean;
  onDelete: () => void;
}) {
  const intl = useIntl();
  const label = intl.formatMessage(isSubmitted ? messages.deleteLocalRecord : messages.deleteLocalDraft);

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: only stops bubbling to the row; the button inside is the control
    <span onClick={event => event.stopPropagation()} onKeyDown={event => event.stopPropagation()}>
      <Popconfirm
        cancelText={intl.formatMessage(messages.appCommonCancel)}
        okButtonProps={{ danger: true }}
        okText={label}
        onConfirm={onDelete}
        title={intl.formatMessage(isSubmitted ? messages.deleteLocalRecordConfirm : messages.deleteLocalDraftConfirm)}
      >
        <Button danger icon={<DeleteOutlined />} loading={isDeleting} size="small" type="text">
          {label}
        </Button>
      </Popconfirm>
    </span>
  );
}
